import { render } from "./KhmerVersion.vue?vue&type=template&id=3f2aeca6&scoped=true"
import script from "./KhmerVersion.vue?vue&type=script&lang=js"
export * from "./KhmerVersion.vue?vue&type=script&lang=js"

import "./KhmerVersion.vue?vue&type=style&index=0&id=3f2aeca6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f2aeca6"]])

export default __exports__